
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/central-doctrine",
      function () {
        return require("private-next-pages/central-doctrine/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/central-doctrine"])
      });
    }
  